<template>
<div class="chapter">
<div class="inner_page">
<div class="block">
<p class="center"><em>For God is deaf nowadays and will not hear us</em>,<br/><em>And for our guilt he grinds good men to dust</em>.</p>
<p class="center">—<span class="small">WILLIAM LANGLAND</span>,<br/>Piers Ploughman</p>
</div>
<div class="block">
<p class="center"><em>C’est le chemin qu’on appelle le Val d’ Enfer. Que votre Altesse me pardonne l’expression; je ne suis pas diable pour y passer</em>.</p>
<p class="center">—<span class="small">MARSHAL VILLARS</span>,<br/>regarding the Höllenthal, 1702</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780765340351_epub_prf1_r1.vue?655aa0ba